export default "__VITE_ASSET__C1A26l6h__"